<template>
  <div id="cooperation" class="franchise-offer my-110">
    <div class="franchise-offer-info flex">
      <div class="franchise-offer-info-logo">
        <div>{{ data.title }}</div>
        <img src="/svg/logo/vz-logo-white.svg" alt=""/>
      </div>
      <div class="franchise-offer-info-text color-primary">
        <vz-icon
          name="alert-circle-outline"
          size="36"
          variant="primary"
          class="mr-10"
        />
        <div>{{ data.description }}</div>
      </div>
    </div>
    <div class="franchise-offer-form public-container-mobile">
      <vz-commercial-offer-form />
    </div>
  </div>
</template>

<script setup lang="ts">
import VzCommercialOfferForm from '~/components/forms/vz-commercial-offer-form.vue'
import {getPageContent} from '~/api/content';

const data = (await getPageContent('/franchise')).blocks?.cooperation
</script>
